/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SeizableIncomePeriodResponse
 */
export interface SeizableIncomePeriodResponse {
    /**
     * 
     * @type {Date}
     * @memberof SeizableIncomePeriodResponse
     */
    from: Date;
    /**
     * 
     * @type {Date}
     * @memberof SeizableIncomePeriodResponse
     */
    to: Date | null;
}

/**
 * Check if a given object implements the SeizableIncomePeriodResponse interface.
 */
export function instanceOfSeizableIncomePeriodResponse(value: object): value is SeizableIncomePeriodResponse {
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    return true;
}

export function SeizableIncomePeriodResponseFromJSON(json: any): SeizableIncomePeriodResponse {
    return SeizableIncomePeriodResponseFromJSONTyped(json, false);
}

export function SeizableIncomePeriodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeizableIncomePeriodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'from': (new Date(json['from'])),
        'to': (json['to'] == null ? null : new Date(json['to'])),
    };
}

export function SeizableIncomePeriodResponseToJSON(json: any): SeizableIncomePeriodResponse {
    return SeizableIncomePeriodResponseToJSONTyped(json, false);
}

export function SeizableIncomePeriodResponseToJSONTyped(value?: SeizableIncomePeriodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': `${value['from'].getFullYear()}-${String(value['from'].getMonth()+1).padStart(2,'0')}-${String(value['from'].getDate()).padStart(2,'0')}`,
        'to': value['to'] == null ? value['to'] : `${value['to'].getFullYear()}-${String(value['to'].getMonth()+1).padStart(2,'0')}-${String(value['to'].getDate()).padStart(2,'0')}`,
    };
}

